import { Box, useTheme } from "@mui/material";
import React from "react";

const CommunicationWaysIconWrapper = ({ children }) => {
  const theme = useTheme();

  return (
    <>
      <Box
        bgcolor={theme.palette.primary.main}
        sx={{
          padding: 2,
          width: 4,
          height: 4,
          borderRadius: "50%",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
        }}
      >
        {children}
      </Box>
    </>
  );
};

export default CommunicationWaysIconWrapper;
